// extracted by mini-css-extract-plugin
export default {"root":"HelpBtnsWrapper_root__BD2j7","avatarIcon":"HelpBtnsWrapper_avatarIcon__DF3FE"};